export default {
    menuMusic: null,
    comms: null,
    missionMusic: null,
    simMusic: null,
    countdown: null,
    explode: null,
    button_click: null
};


//////////////////
// WEBPACK FOOTER
// ./src/sounds.js
// module id = 44
// module chunks = 0